export function InputController(name, controller = () => {}) {
	const onChangeInput = (e) => {
		controller((p) => {
			return { ...p, [name]: e };
		});
	};

	return { onChangeInput };
}

export function InputContValue(controller = () => {}, name, val) {
	controller((p) => {
		return { ...p, [name]: val };
	});
}
